var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("table-filter", {
        staticClass: "filter pull-right",
        attrs: { focusOnLoad: _vm.focusFilterOnLoad },
        model: {
          value: _vm.filter,
          callback: function($$v) {
            _vm.filter = $$v
          },
          expression: "filter"
        }
      }),
      _vm._v(" "),
      _c("table", { staticClass: "areas-table" }, [
        _c(
          "thead",
          _vm._l(_vm.headers, function(header, index) {
            return _c("th", { key: header + "-" + index }, [
              _vm._v("\n                " + _vm._s(header) + "\n            ")
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.processedItems, function(item) {
            return _c(
              "ExpandableDataTableRow",
              {
                key: item.id.label,
                attrs: {
                  item: item,
                  label: _vm.label,
                  level: 0,
                  visible: item.visible,
                  filtered: _vm.filter != ""
                },
                on: {
                  "select-item": function($event) {
                    return _vm.$emit("select-item", $event)
                  },
                  clone: function($event) {
                    return _vm.$emit("clone", $event)
                  },
                  delete: function($event) {
                    return _vm.$emit("delete", $event)
                  },
                  edit: function($event) {
                    return _vm.$emit("edit", $event)
                  },
                  statistics: function($event) {
                    return _vm.$emit("statistics", $event)
                  }
                }
              },
              [_vm._t("default")],
              2
            )
          }),
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }